/**
 *
 * @param action
 * @param extend T
 * @returns Promise<any> & T
 */
export function extendPromise(action, extend = {}) {
  let cachedAction = null;
  let getAction = () => {
    if(!cachedAction)
      cachedAction = action();
    return cachedAction;
  };

  return {
    ...extend,
    then: (...args) => getAction().then(...args),
    catch: (...args) => getAction().catch(...args)
  };
}



// WEBPACK FOOTER //
// ./src/helpers/extend-promise.js